module.exports = __webpack_public_path__ + "img/Red teaSIM 1 手机@2x.896770d5.png";